import { convertCurrencyToNumber, formatWeightAnimal } from '.'

export const formatPerimeterAnimal = (value: string | number): string => {
  if (!value) return ''
  return formatWeightAnimal(value).replace('KG', 'CM')
}

// Função para converter peso formatado de volta para número
export const convertWeightToNumber = (value: string): number | null => {
  if (!value) return null

  // Remove 'KG' e espaços
  const cleanValue = String(value).replace(/KG|kg|\s/g, '')

  // Substitui vírgula por ponto para decimal
  const numericValue = cleanValue.replace(',', '.')

  const parsed = parseFloat(numericValue)
  return isNaN(parsed) ? null : parsed
}

// Função para converter perímetro formatado de volta para número
export const convertPerimeterToNumber = (value: string): number | null => {
  if (!value) return null

  // Remove 'CM' e espaços
  const cleanValue = String(value).replace(/CM|cm|\s/g, '')

  // Substitui vírgula por ponto para decimal
  const numericValue = cleanValue.replace(',', '.')

  const parsed = parseFloat(numericValue)
  return isNaN(parsed) ? null : parsed
}

// Mapeamento de campos que precisam de formatação numérica por tabela
export const NUMERIC_FIELDS_MAPPING = {
  VendaAnimal: {
    valorArroba: convertCurrencyToNumber,
    valorTotal: convertCurrencyToNumber
  },
  Animal: {
    pesoAtual: convertWeightToNumber,
    perimetro: convertPerimeterToNumber,
    fitaPerimetro: convertPerimeterToNumber,
    fitaComprimento: convertPerimeterToNumber
  },
  AnimalHistorico: {
    pesoAtual: convertWeightToNumber,
    perimetro: convertPerimeterToNumber,
    fitaPerimetro: convertPerimeterToNumber,
    fitaComprimento: convertPerimeterToNumber
  },
  Lote: {
    // Adicione campos do lote que precisam formatação numérica aqui
  },
  Morte: {
    // Adicione campos de morte que precisam formatação numérica aqui
  },
  ProcessoCobertura: {
    // Adicione campos de processo de cobertura que precisam formatação numérica aqui
  }
}

// Função genérica para aplicar formatação numérica aos campos do payload
export const applyNumericFormatting = (tableName: string, bodyRequest: any): any => {
  const tableMapping = NUMERIC_FIELDS_MAPPING[tableName as keyof typeof NUMERIC_FIELDS_MAPPING]

  if (!tableMapping) {
    return bodyRequest
  }

  const formattedBodyRequest = { ...bodyRequest }

  Object.keys(tableMapping).forEach((fieldName) => {
    const converterFunction = tableMapping[fieldName as keyof typeof tableMapping] as
      | ((value: string) => number | null)
      | undefined
    const fieldValue = formattedBodyRequest[fieldName]

    if (fieldValue !== undefined && fieldValue !== null && converterFunction) {
      const convertedValue = converterFunction(String(fieldValue))
      if (convertedValue !== null) {
        formattedBodyRequest[fieldName] = convertedValue
      }
    }
  })

  return formattedBodyRequest
}
